/* @flow */
import React from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import SimpleSelect from 'components/SimpleSelect/SimpleSelect';

import s from '../RushAssetRequestForm.module.scss';

import CatalogueContext from '../utilities/CatalogueContext/CatalogueContext';

type DetailsDisplaysOrPeripheralsProps = {
  field: Object,
  title: 'Displays' | 'Peripherals',
  assetTitleField: Object,
};

type QtyAssetProps = {
  id: string,
  quantity: number,
};

const StyledFormControl = withStyles({
  root: {
    display: 'flex',
    width: 'fit-content',
    flexDirection: 'row',
  },
})(FormControl);

class DetailsDisplaysOrPeripheralsSection extends React.Component<DetailsDisplaysOrPeripheralsProps> {
  handleToggle = (asset: Object) => {
    const { field, assetTitleField } = this.props;
    const tempArray: Array<QtyAssetProps> = [...field.value];

    const exists = tempArray.find(a => a.id === asset.id);
    const optionIndex: number = field.value.indexOf(exists);

    if (optionIndex !== -1) {
      // Remove option from field.value
      tempArray.splice(optionIndex, 1);
      if (assetTitleField?.value === asset.ui_displayed_description) {
        assetTitleField.set('');
      }
    } else {
      // Add option to field.value
      tempArray.push({ id: asset.id, quantity: 1 });
      if (!assetTitleField.value) {
        assetTitleField.set(asset.ui_displayed_description);
      }
    }

    field.set(tempArray);
  };

  handleQuantityChange = (assetId: string, quantity: number) => {
    const { field } = this.props;
    const tempArray: Array<QtyAssetProps> = [...field.value];

    const updated = tempArray.map(existing =>
      existing.id === assetId ? { ...existing, quantity } : existing
    );

    field.set(updated);
  };

  isAssetSelected = (assetId: string) => {
    const { field } = this.props;
    return Array.isArray(field.value) && field.value.some(existing => existing.id === assetId);
  };

  getAssetQuantity = (assetId: string) => {
    const { field } = this.props;
    if (field.value) {
      const found = field.value.find(a => a.id === assetId);
      return found?.quantity || 0;
    }
    return 0;
  };

  render() {
    return (
      <CatalogueContext.Consumer>
        {({ displays, peripherals }) => {
          const { title } = this.props;
          const assetArray = title === 'Displays' ? displays : peripherals;
          return (
            <div>
              <p className={s['software-section__title']}>{title}</p>
              <div className={s['software-section__container']}>
                {assetArray.map(asset => {
                  const isChecked = this.isAssetSelected(asset.id);
                  const quantity = this.getAssetQuantity(asset.id);

                  return (
                    <div className={s['disp-periph__container']} key={asset.id}>
                      <StyledFormControl>
                        <FormControlLabel
                          className={s['disp-periph__checkbox-label']}
                          label={asset.ui_displayed_description}
                          control={
                            <Checkbox
                              checked={isChecked}
                              onChange={() => this.handleToggle(asset)}
                            />
                          }
                        />
                      </StyledFormControl>
                      <SimpleSelect
                        disabled={!isChecked}
                        label="Quantity"
                        value={quantity}
                        onChange={e =>
                          this.handleQuantityChange(asset.id, parseInt(e.target.value, 10))
                        }
                        options={Array.from({ length: 10 }, (_, i) => ({
                          id: i + 1,
                          name: i + 1,
                        }))}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }}
      </CatalogueContext.Consumer>
    );
  }
}

export default DetailsDisplaysOrPeripheralsSection;
